'use client';

import { FC } from 'react';
import { Alert, Pill, Button, ButtonGroup } from '@/_components';
import { PreviewAlertProps } from './PreviewAlert.types';
import styles from './PreviewAlert.module.css';
import { useRouter } from 'next/navigation';

export const PreviewAlert: FC<PreviewAlertProps> = () => {
  const { push } = useRouter();

  const onHistoryBack = () => {
    const hasHistory: boolean = window?.history?.length > 1;

    if (typeof window === 'undefined' || !hasHistory) {
      return push('/admin');
    }

    return window.history.back();
  };

  return (
    <Alert type="info" icon={null} className={styles.previewAlert}>
      <ButtonGroup>
        <Button
          size="tiny"
          intent="secondary"
          value="Back"
          isIconOnly={true}
          withTooltip
          tooltipPlacement="bottom"
          onClick={onHistoryBack}
          iconLeft="arrow-left"
        />
        <Pill
          label="Preview"
          intent="accent"
          isRound={true}
          size="large"
          className="mobile:hidden flex"
        />
      </ButtonGroup>
    </Alert>
  );
};
